/**
 * @generated SignedSource<<ae311e6c3bb9e52e105885c8dd7bf55b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductRegistrationAvailability = "hidden" | "private" | "public" | "%future added value";
export type ProductSelect_PaginationQuery$variables = {
  after?: string | null;
  filterByAdminAccess?: boolean | null;
  first: number;
  hideNonEventAppProducts: boolean;
  hideNonPublic: boolean;
  id: string;
  ids?: ReadonlyArray<string> | null;
  search?: string | null;
  type?: string | null;
  viewerIsMember?: boolean | null;
};
export type ProductSelect_PaginationQuery$data = {
  readonly organization: {
    readonly products?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly badge: {
            readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
          } | null;
          readonly hasEventsApp?: boolean;
          readonly id: string;
          readonly isAutoJoined: boolean;
          readonly name: string;
          readonly registrationAvailability: ProductRegistrationAvailability;
          readonly slug: string;
          readonly viewerPermissions: ReadonlyArray<string>;
          readonly " $fragmentSpreads": FragmentRefs<"ProductDropdownItemFragment">;
        };
      }>;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
        readonly hasPreviousPage: boolean;
        readonly startCursor: string | null;
      };
    };
  } | null;
};
export type ProductSelect_PaginationQuery = {
  response: ProductSelect_PaginationQuery$data;
  variables: ProductSelect_PaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByAdminAccess"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hideNonEventAppProducts"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hideNonPublic"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ids"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewerIsMember"
},
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v11 = {
  "kind": "Variable",
  "name": "filterByAdminAccess",
  "variableName": "filterByAdminAccess"
},
v12 = {
  "kind": "Variable",
  "name": "hideNonPublic",
  "variableName": "hideNonPublic"
},
v13 = {
  "kind": "Variable",
  "name": "ids",
  "variableName": "ids"
},
v14 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v15 = {
  "kind": "Variable",
  "name": "type",
  "variableName": "type"
},
v16 = {
  "kind": "Variable",
  "name": "viewerIsMember",
  "variableName": "viewerIsMember"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAutoJoined",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "registrationAvailability",
  "storageKey": null
},
v23 = {
  "condition": "hideNonEventAppProducts",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "hasEventsApp",
      "args": [
        {
          "kind": "Literal",
          "name": "kind",
          "value": "events"
        }
      ],
      "kind": "ScalarField",
      "name": "hasProductApp",
      "storageKey": "hasProductApp(kind:\"events\")"
    }
  ]
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v11/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductSelect_PaginationQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v10/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "products",
                "args": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "concreteType": "ProductNodeConnection",
                "kind": "LinkedField",
                "name": "__ProductSelectQuery__products_connection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Badge",
                            "kind": "LinkedField",
                            "name": "badge",
                            "plural": false,
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "BadgeFragment"
                              }
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ProductDropdownItemFragment"
                          },
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductSelect_PaginationQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v10/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v24/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v27/*: any*/),
                "concreteType": "ProductNodeConnection",
                "kind": "LinkedField",
                "name": "products",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Badge",
                            "kind": "LinkedField",
                            "name": "badge",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "kind",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "icon",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "emoji",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mediaUrl",
                                "storageKey": null
                              },
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startsAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endsAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v27/*: any*/),
                "filters": [
                  "type",
                  "hideNonPublic",
                  "ids",
                  "viewerIsMember",
                  "filterByAdminAccess",
                  "search"
                ],
                "handle": "connection",
                "key": "ProductSelectQuery__products",
                "kind": "LinkedHandle",
                "name": "products"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          },
          (v17/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8af5b0d15594c45706251325c4ad8a73",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "organization",
            "products"
          ]
        }
      ]
    },
    "name": "ProductSelect_PaginationQuery",
    "operationKind": "query",
    "text": "query ProductSelect_PaginationQuery(\n  $id: ID!\n  $type: String\n  $hideNonPublic: Boolean!\n  $ids: [ID!]\n  $viewerIsMember: Boolean\n  $hideNonEventAppProducts: Boolean!\n  $filterByAdminAccess: Boolean\n  $first: Int!\n  $after: String\n  $search: String\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      products(type: $type, hideNonPublic: $hideNonPublic, ids: $ids, viewerIsMember: $viewerIsMember, filterByAdminAccess: $filterByAdminAccess, first: $first, after: $after, search: $search) {\n        edges {\n          node {\n            id\n            name\n            slug\n            isAutoJoined\n            viewerPermissions\n            registrationAvailability\n            badge {\n              ...BadgeFragment\n              id\n            }\n            hasEventsApp: hasProductApp(kind: events) @include(if: $hideNonEventAppProducts)\n            ...ProductDropdownItemFragment\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ProductDropdownItemFragment on Product {\n  name\n  type\n  startsAt\n  endsAt\n  status\n  badge {\n    ...BadgeFragment\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "69985d5f6062d77f6a03f2f4033c0dfc";

export default node;
